import classNames from 'classnames';
import React, { JSX } from 'react';
import { styled } from '@mui/material/styles';

export type IButtonProps = JSX.IntrinsicElements['button'] & {
	color?: 'primary' | 'secondary' | 'warning' | 'danger' | 'info';
};

export const Button = styled(
	({ className, children, color, ...props }: IButtonProps) => {
		return (
			<button
				type="button"
				className={classNames('button', color && `button--${color}`, className)}
				{...props}
			>
				{children}
			</button>
		);
	},
	{ label: 'Button', target: 'Button-root' },
)({
	color: 'var(--button_color)',
	background: 'var(--button_background)',
	fontFamily: 'Ubuntu, sans-serif',
	fontWeight: 'bold',
	textTransform: 'uppercase',
	fontSize: '1.6em',
	borderRadius: '6px 6px 0 6px',
	padding: '6px 12px',
	transition: 'all 150ms',
	'&:not([disabled]):hover': {
		background: 'var(--button--hover_background)',
		color: 'var(--button--hover_color)',
	},
	'&[disabled]': {
		opacity: 'var(--button--disabled_opacity)',
		cursor: 'not-allowed',
	},
	'&.button--primary': {
		color: 'var(--button_color)',
		background: 'var(--button_background)',
		'&:not([disabled]):hover': {
			background: 'var(--button--hover_background)',
			color: 'var(--button--hover_color)',
		},
	},
	'&.button--secondary': {
		color: 'var(--button--secondary_color)',
		background: 'var(--button--secondary_background)',
		'&:not([disabled]):hover': {
			background: 'var(--button--secondary--hover_background)',
			color: 'var(--button--secondary--hover_color)',
		},
	},
	'&.button--success': {
		color: 'var(--button--success_color)',
		background: 'var(--button--success_background)',
		'&:not([disabled]):hover': {
			background: 'var(--button--success--hover_background)',
			color: 'var(--button--success--hover_color)',
		},
	},
	'&.button--warning': {
		color: 'var(--button--warning_color)',
		background: 'var(--button--warning_background)',
		'&:not([disabled]):hover': {
			background: 'var(--button--warning--hover_background)',
			color: 'var(--button--warning--hover_color)',
		},
	},
	'&.button--danger': {
		color: 'var(--button--danger_color)',
		background: 'var(--button--danger_background)',
		'&:not([disabled]):hover': {
			background: 'var(--button--danger--hover_background)',
			color: 'var(--button--danger--hover_color)',
		},
	},
	'&.button--info': {
		color: 'var(--button--info_color)',
		background: 'var(--button--info_background)',
		'&:not([disabled]):hover': {
			background: 'var(--button--info--hover_background)',
			color: 'var(--button--info--hover_color)',
		},
	},
});
